import moment from "moment-timezone";

const TZ = "Asia/Jakarta";

/** A stored time as a moment, or an invalid one when absent — moment(undefined) is "now". */
const at = (value) => (value ? moment(value).tz(TZ) : moment.invalid());

/**
 * The homepage badge for an event: "FINISHED", "LIVE NOW" or "UPCOMING".
 *
 * A category is timed by its start and cut-off. A hand-timed category
 * (buzzer / input-ninja) has neither, so it is judged by the event's date
 * instead: before that day it is upcoming, on it live, after it finished.
 * Without this, an event made only of such categories read UPCOMING on race
 * day and forever after, until someone marked it completed by hand.
 */
export const eventBadge = ({ status, categories = [], date, now = moment() }) => {
  if (status === "completed") return "FINISHED";
  const t = moment(now).tz(TZ);
  const day = date ? moment.tz(date, "YYYY-MM-DD", TZ) : moment.invalid();

  const stateOf = (category) => {
    const start = at(category.startTime);
    const cutOff = at(category.cutOffTime);
    if (start.isValid() || cutOff.isValid()) {
      if (cutOff.isValid() && t.isAfter(cutOff)) return "finished";
      if (start.isValid() && t.isAfter(start)) return "live";
      return "upcoming";
    }
    if (!day.isValid()) return "upcoming";
    if (t.isBefore(day.clone().startOf("day"))) return "upcoming";
    if (t.isAfter(day.clone().endOf("day"))) return "finished";
    return "live";
  };

  const states = categories.map(stateOf);
  if (states.every((s) => s === "finished")) return "FINISHED";
  if (states.some((s) => s === "live" || s === "finished")) return "LIVE NOW";
  return "UPCOMING";
};
